import { format } from 'date-fns'
import React from 'react'

import type { RevenueMonth } from '../types/executives'
const Months = ({ revenueMonth }: { revenueMonth: RevenueMonth[] }) => {
    if (!revenueMonth) return null

    return (
        <div className="col-12">
            <div className="table-group">
                <div className="table-body table-responsive p-0">
                    <table className="table">
                        <thead>
                            <tr>
                                <th>Period</th>
                                <th>Selected Revenue</th>
                                <th>Previous Revenue</th>
                                <th>Selected Margin</th>
                                <th>Previous Margin</th>
                                <th>Revenue Discrepancy</th>
                            </tr>
                        </thead>
                        <tbody>
                            {revenueMonth?.length > 0 ? (
                                revenueMonth.map((period, index) => (
                                    <tr key={index}>
                                        <td>
                                            <span className="text-color-1">
                                                {format(
                                                    new Date(
                                                        period.year,
                                                        period.month,
                                                        1,
                                                    ),
                                                    'MMM yyyy',
                                                )}
                                            </span>
                                        </td>
                                        <td>${period.selectedRevenue}</td>
                                        <td>${period.previousRevenue}</td>
                                        <td>${period.selectedMargin}</td>
                                        <td>${period.previousMargin}</td>
                                        <td>${period.revenueDiscrepancy}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={6}>
                                        <h4 className="text-center">
                                            Periods not found
                                        </h4>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default Months
